module.exports = __webpack_public_path__ + "img/sequence1.1280bb9d.png";